  import { createFeature, createReducer, on } from '@ngrx/store';

import * as actions from './maf-ltc-save.actions';
import { SharedPageTypeEnum } from 'src/app/shared/navigation/page-type.enum';
import { MafLtcSaveResponseI } from 'src/app/api/maf-ltc-save/maf-ltc-save-result.int';
import { MafLtcSaveQueryI } from 'src/app/api/maf-ltc-save/maf-ltc-save-query.int';

interface StateObjectI {
  data: MafLtcSaveResponseI;
  errorMessage: string;
  loaded: boolean;
  loading: boolean;
  query: MafLtcSaveQueryI;
}

export interface State {
  lastUsedPageType: SharedPageTypeEnum;
  [SharedPageTypeEnum.infCnt]: StateObjectI;
}

export const initialState: State = {
  lastUsedPageType: null,
  [SharedPageTypeEnum.infCnt]: {
    data: null,
    errorMessage: null,
    loaded: null,
    loading: null,
    query: null,
  },
};

export default createFeature({
  name: 'mafLtcSave',
  reducer: createReducer(
  initialState,
  on(actions.error, (state: State, { pageType, messageText }): State => ({
    ...state,
    [pageType]: {
      ...state[pageType],
      loading: false,
      errorMessage: messageText
    }
  })),
  on(actions.load, (state: State, { pageType, query }): State => ({
    ...state,
    lastUsedPageType: pageType,
    [pageType]: {
      ...state[pageType],
      loading: true,
      query,
    }
  })),
  on(actions.received, (state: State, { pageType, data }): State => ({
    ...state,
    [pageType]: {
      ...state[pageType],
      loaded: true,
      loading: false,
      data,
    }
  })),
  on(actions.reset, (_state: State, { }): State => ({
    ...initialState,
  })),
  )}
);